import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import HorizontalDivider from '../HorizontalDivider';
import {
  ArrowImg,
  ImageWrapper,
  RelatedProductsWrapper,
  SliderCell,
  SliderRow,
  Subtext,
  Title,
  ViewMore
} from './RelatedProducts.css';
import withCountryCode from '../../../components/RoutesHoc/RoutesHoc';
import RelatedProductLink from './RelatedProductLink';
import TrackingEvents from '../../../common/models/TrackingEvents';

class RelatedProducts extends Component {
  componentDidMount() {
    const { brandName } = this.props;
    mixpanel.track_links(`#more-brand`, TrackingEvents.designerSelected(), { designer: brandName });
  }

  render() {
    const {
      brandUrl,
      brandName,
      currencySymbol,
      department,
      products,
      s3BasePath,
      buildUrlWithCountry,
      showSale = false
    } = this.props;

    return (
      <RelatedProductsWrapper data-cy="products-related">
        <Title>More from {brandName}</Title>

        <HorizontalDivider />

        <Subtext>
          Slide to scroll
          <ArrowImg src={`${s3BasePath}mkt/icon/arrow_right_grey.png`} />
        </Subtext>

        <SliderRow>
          <Fragment>
            {products.map(product => (
              <SliderCell key={product.url}>
                <RelatedProductLink
                  currencySymbol={currencySymbol}
                  showSale={showSale}
                  product={product}
                  s3BasePath={s3BasePath}
                />
              </SliderCell>
            ))}
          </Fragment>
          <SliderCell key="view_more">
            <a id="more-brand" href={buildUrlWithCountry(brandUrl)}>
              <ImageWrapper>
                <ViewMore>
                  {`View more from `}
                  <span>{brandName}</span>
                </ViewMore>
              </ImageWrapper>
            </a>
          </SliderCell>
        </SliderRow>

        <HorizontalDivider />
      </RelatedProductsWrapper>
    );
  }
}
RelatedProducts.propTypes = {
  brandName: PropTypes.string.isRequired,
  brandUrl: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  department: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  showSale: PropTypes.bool
};

export default withCountryCode(RelatedProducts);
